<template>
  <v-card
    width="400"
    elevation="24"
  >
    <v-row
      align="center"
      justify="center"
      style="height: 100%; min-height: 400px"
    >
      <v-col>
        <v-row
          align="center"
          justify="center"
          class="my-5 mx-10"
          id="login-header"
        >
          <h1 v-if="alreadyActivated"> Your Account is Already Active </h1>
          <h1 style="text-align:center" v-else> Please set an account password to access the challenge</h1>
        </v-row>
        <v-row
          align="center"
          justify="center"
          style="height: 100%"
          v-if="alreadyActivated"
        >
          <v-btn
            height="50px"
            class="login-form-element"
            color="rgb(255, 149, 24)"
            rounded
            @click="loginRedirect"
          >
            Go Back To Login
          </v-btn>
        </v-row>
        <v-form
          ref="form"
          v-model="valid"
          v-else
        >
          <v-row
            align="center"
            justify="center"
          >
          <v-col>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="organization"
                  color="orange"
                  class="login-form-element"
                  label="Organization"
                  rounded
                  solo
                  prepend-inner-icon="mdi-domain"
                  :rules="organizationRules"
                  :disabled="this.$route.query.token !== 'root'"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="email"
                  color="orange"
                  class="login-form-element"
                  label="E-mail Address"
                  rounded
                  solo
                  prepend-inner-icon="mdi-email"
                  :rules="emailRules"
                  :disabled="this.$route.query.token !== 'root'"
                />
              </v-row>
              <v-row
                v-if="this.$route.query.token === 'root'"
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="username"
                  color="orange"
                  class="login-form-element"
                  label="Full name"
                  rounded
                  solo
                  prepend-inner-icon="mdi-account"
                  :rules="usernameRules"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="password"
                  color="orange"
                  class="login-form-element"
                  label="Password"
                  rounded
                  solo
                  prepend-inner-icon="mdi-key"
                  type="password"
                  :rules="passwordRules"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="confirmedPassword"
                  color="orange"
                  class="login-form-element"
                  label="Confirm Password"
                  rounded
                  solo
                  prepend-inner-icon="mdi-key"
                  type="password"
                  :rules="[confirmPasswordRule]"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-btn
                  height="50px"
                  class="login-form-element"
                  color="rgb(255, 149, 24)"
                  rounded
                  @click="validateRegistration"
                >
                  Create New Account
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Registration',
  data: () => ({
    alreadyActivated: false,
    valid: false,
    organization: '',
    email: '',
    username: '',
    password: '',
    confirmedPassword: '',
    usernameRules: [v => !!v || 'Name is required'],
    organizationRules: [v => !!v || 'Organization is required'],
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
    ],
    passwordRules: [v => !!v || 'Password is required']
  }),

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),

    confirmPasswordRule () {
      return () => (this.password === this.confirmedPassword) || 'Password must match'
    }
  },

  mounted () {
    if (this.$route.query.token === 'root') {
      this.email = ''
      this.organization = 'Basadur'
    } else {
      this.getUserInfoFromToken()
    }
  },

  methods: {
    ...mapMutations(['setBearerToken']),
    ...mapActions(['requestUserInfo', 'requestOrganization']),
    validateRegistration () {
      if (this.$refs.form.validate()) {
        this.registerUser()
      }
    },

    async getUserInfoFromToken () {
      const token = this.$route.query.token
      this.setBearerToken(token)

      console.log('requesting')

      await this.requestUserInfo()

      const organization = await this.requestOrganization(this.userInfo.organization)

      this.email = this.userInfo.email
      this.organization = organization.name
      this.alreadyActivated = this.userInfo.activated
    },

    async registerUser () {
      if (!await this.rootIsInitialized()) {
        this.registerRootUser().then(console.log)
        this.loginRedirect()
      } else {
        this.activateNonRootUser('admin').then(console.log)
        this.loginRedirect()
      }
    },

    async activateNonRootUser (type) {
      const endpoint = '/id/updatePass' // TODO there are api calls here but as far as I understand this whole file will be deleted as there is no more user registration flow

      const body = {
        token: this.$route.query.token,
        password: this.password
      }

      var response = await fetch(process.env.VUE_APP_API_BASE + endpoint, {
        method: 'post',
        body: JSON.stringify(body)
      })

      return await response.json()
    },

    async registerRootUser () {
      const endpoint = '/id/init'

      const body = {
        organization: this.organization,
        email: this.email,
        name: this.username,
        password: this.password
      }

      var response = await fetch(process.env.VUE_APP_API_BASE + endpoint, {
        method: 'post',
        body: JSON.stringify(body)
      })

      return await response.json()
    },

    async rootIsInitialized () {
      const endpoint = '/id/initStatus'
      var response = await fetch(process.env.VUE_APP_API_BASE + endpoint)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      } else {
        var json = await response.json()

        return json.isInit
      }
    },

    loginRedirect () {
      let challenge = ''
      if (this.$route.query.challenge) {
        challenge = this.$route.query.challenge
      }
      this.$router.push(`/login?challenge=${challenge}`)
    }
  }
}
</script>

<style lang="sass" scoped>
  #login-header
    top: -10px

  .login-form-element
    width: 75%
    max-width: 75%
</style>
